// DateConditionMode lives in it's own file to keep workbook- and non-workbook-dependencies apart.

/** @see net/disy/cadenza/workbook/model/condition/DateConditionMode.java */
export const DateConditionMode = {
  CALENDAR: 'Calendar',
  SLIDER: 'Slider'
} as const;
